<!--
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-25 13:45:08
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-25 15:26:16
 * @FilePath: /wemeet-admin-new/src/components/ExportDrawer.vue
 * @Description: 
 * Copyright (c) 2025 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer direction="rtl" :model-value="visible" :size="600" :title="title" @close="close">
    <div class="containerForm">
      <el-button icon="refresh" style="float: right; margin: 0 4px 8px 0" type="primary" @click="refresh">
        刷新
      </el-button>
      <el-table v-if="data.length" :data="data">
        <el-table-column label="类型">
          <template #default>{{ title }}</template>
        </el-table-column>
        <el-table-column label="导出时间" prop="createTime" />
        <el-table-column align="center" label="状态" width="112">
          <template #default="{ row }">
            <el-tag v-if="row.status === status.SUCCESS" type="success">生成成功</el-tag>
            <el-tag v-else-if="row.status === status.PENDING" type="info">生成中...</el-tag>
            <el-tag v-else type="danger">生成失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="112">
          <template #default="{ row }">
            <el-link
              :disabled="row.status !== status.SUCCESS"
              type="primary"
              :underline="false"
              @click="download(row.fileUrl)"
            >
              下载
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="close">关闭</el-button>
    </div>
  </el-drawer>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue'

  const props = defineProps({
    visible: Boolean,
    title: String,
    data: Object,
  })

  const emit = defineEmits(['refresh', 'close'])

  const status = {
    SUCCESS: 'SUCCESS',
    PENDING: 'PENDING',
    FAIL: 'FAIL',
  }

  function refresh() {
    emit('refresh')
  }

  function close() {
    emit('close')
  }

  function download(fileUrl) {
    window.open(fileUrl)
  }
</script>

<style lang="scss" scoped>
  .containerForm {
    height: 85vh;
    width: 100%;
    overflow-y: auto;
  }
</style>
